export const GIGLINKED_CUT_PERCENT = 0.15;
export const CANADA_GST = 0.05;
export const QUEBEC_QST = 0.09975;
